@if (shippingMethod) {
<p class="p1">
    {{shippingMethod.title}}&nbsp;-&nbsp;
    @if (shippingMethod.price === 0) {
    <span class="uppercase">{{'FREE' | translate}}</span>
    } @else {
    <price [value]="shippingMethod.price" />
    }
</p>
}
